export const DESKTOP_MEDIA = 1200
